<template>
    <div> 
        <v-card flat  v-if="ud"
            color="lighten-1" class="b1">   
            
            
            <!-- //LAST DAYS -->
            <v-list dense class="mx-5" v-if="false">
                <div  v-for="(item,index) in OptionalDays" :key="index" > 
                    <v-list-item @click="CHANGE_DATE(item)">
                        <div :class="DIFF(inputFromDate,inputToDate)==item.days?'secondary--text':''">{{item.name}}</div>
                    </v-list-item> 
                </div> 
            </v-list>

            <!-- //DAYSHIFT TABLE -->
            <div class="ml-4">
                <v-card class="mr-5 mt-2" tile>

                    <!-- //TITLE -->
                    <v-card dark color="primary  "  tile  > 
                        <v-layout row class="ma-0" align-center> 
                            <div class="ml-5 py-3">Select Dayshift</div>
                            <v-spacer></v-spacer>
                            <v-autocomplete v-if="MBS.actions.SIZE(OutletsFilter)>1"
                                class="mt-1 mr-1"
                                v-model="input_outlets"
                                dense deletable-chips
                                label="Select Outlet"
                                multiple outlined
                                small-chips clearable
                                :items="OutletsFilter"
                                prepend-inner-icon="mdi-sitemap"
                                item-value="code"
                                item-text="name"
                                :disabled="filter_dayshifts_fixed"
                                ></v-autocomplete>
                        </v-layout>
                    </v-card>
                    
                    <!-- // //TABLE -->
                    <v-data-table dense flat  
                        :height="(body_height-190)>200?body_height-190:200" 
                        fixed-header
                        v-model="selected"
                        :hide-default-footer="false"
                        :headers="headers"
                        :items="DayShiftsFiltered"
                        :single-select="false"
                        item-key="key"
                        :show-select="true" >
                    </v-data-table>  
                </v-card>
 
            </div> 

            <v-layout class="ml-3 mr-5 mb-0 mt-2"  >
                <v-flex >
                    <v-menu
                        ref="menuFromDate"
                        v-model="menuFromDate"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y 
                        max-width="290px"
                        min-width="auto" >
                        <template v-slot:activator="{ on, attrs }">
                            <v-card v-on="on" height="100%" color="primary" dark class="px-3 py-1 mb-">
                                <v-layout align-center class="ma-0">
                                    <div>
                                        <div class="font-weight-bold not-f2">From</div>
                                        <div class="not-f">{{moment(inputFromDate).format('dddd, Do, MMMM YYYY')}}</div>
                                        <!-- <div>{{moment(inputFromDate).format('ddd, yyyy/MM/DD')}}</div> -->
                                    </div>
                                    <v-spacer></v-spacer>
                                    <v-icon>today</v-icon> 
                                </v-layout> 
                            </v-card> 
                        </template>
                        <v-date-picker
                            v-model="inputFromDate" color="secondary"
                            no-title event-color="primary"
                            :max="max_from_date"
                            :min="min_from_date"
                            @input="menuFromDate = false"
                        ></v-date-picker>
                    </v-menu> 
                </v-flex>
                <v-flex > 
                    <v-menu
                        ref="menuFromDate"
                        v-model="menuToDate"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y 
                        max-width="290px"
                        min-width="auto" >
                        <template v-slot:activator="{ on, attrs }">
                            <v-card v-on="on"  height="100%"    color="primary" dark class="px-3 py-1 ml-1 mb-">
                                <v-layout align-center class="ma-0">
                                    <div>
                                        <div class="font-weight-bold not-f2">To</div>
                                        <div class="not-f">{{moment(inputToDate).format('dddd, Do, MMMM YYYY')}}</div>
                                        <!-- <div>{{moment(inputToDate).format('ddd, yyyy/MM/DD')}}</div> -->
                                    </div>
                                    <v-spacer></v-spacer>
                                    <v-icon>today</v-icon> 
                                </v-layout> 
                            </v-card> 
                        </template>
                        <v-date-picker
                            v-model="inputToDate"
                            :max="max_to_date"
                            :min="min_to_date"
                            no-title color="secondary"
                            @input="menuToDate = false"
                        ></v-date-picker>
                    </v-menu>  
                </v-flex>
            </v-layout>

           
        </v-card>  
    </div>
</template> 
<script>
let NAME = 'DAY-SHIFT-SELECTOR'
import moment from 'moment'
import {mapState} from "vuex"
import DATA from '../../plugins/DATA';
import { toNumber } from '../../plugins/formatNumber';
export default { 
    props:['color','icon_color','title_color','body_height',
        'max_from_date','min_from_date','max_to_date','min_to_date',
        'default_days','optional_dates','on_start','filter_dayshifts','filter_dayshifts_fixed'], 
    data(){
        return{ 
            menuDateSelect:false, 
            select:{
                signOption:'',
                accountType:'',
                businessType:'',
                country:''
            },
            psw1: true, 
            input:{ 
            },
            input_outlets:[],
            item_multiple_select:false,
            inputPhone:'',
            inputLoading:false,
            date:"17/01/2020 - 17/01/2020",
            inputFromDate:moment().subtract(5,'day').format('yyyy-MM-DD'),
            inputToDate:moment().format('yyyy-MM-DD'), 
            menuFromDate:false,
            menuToDate:false, 
            fromDate: null,
            toDate: null,
            difference: null, 
            selected: [],
            headers: [ 
                { text: 'Open', value: 'local_created_at_', cellClass:'with-divider-lr' },
                { text: 'Close', value: 'time_closed', cellClass:'with-divider'  },
                { text: 'Operational', value: 'operating_date_' , cellClass:'with-divider' },
                { text: 'Outlet', value: 'outlet_name' , cellClass:'with-divider' },
                { text: 'User', value: 'user_name' , cellClass:'with-divider-' },
            ],
        }  
    },
    created(){
        this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
        this.MBS.events.$on('GET_DAYSHIFT_SELECTOR_DATA', this.GET_DAYSHIFT_SELECTOR_DATA);  
        this.setOutletsFilter(this.filter_dayshifts) 
        
    },
    mounted(){
        this.input={}
        this.inputLoading=false
        if (this.default_days) {
            let item = {from:this.default_days,from_type:"days"} 
            this.CHANGE_DATE(item)
        } 
        this.fromDate = this.inputFromDate
        this.toDate = this.inputToDate 
        if (this.on_start) {
            this.APPLY_DATE() 
        }
        this.setOutletsFilter(this.filter_dayshifts)  
        
    },
    computed:{
        vs(){
            return this.$vuetify.breakpoint
        }, 
        vsh(){
            return this.vs.height
        }, 
        moment(){ 
            return moment
        }, 
        lastDays(){ 
            return this.MBS.date.moment
        }, 
        ...mapState({
            loading:state=>state.load.loading,
            processes:state=>state.load.processes,
            responses:state=>state.load.responses,
        }),
        ...mapState({
            us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
            ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
        }),
        ...mapState({ 
            Outlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
            JoinedOutlets: state=> state.join[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()], 
            Departments: state=> state.items[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()],
            JoinedDepartments: state=> state.join[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()], 
            DayShifts: state=> state.items[(DATA.ITEMS.DAYS_SHIFTS.values).toUpperCase()],
            JoinedDayShifts: state=> state.join[(DATA.ITEMS.DAYS_SHIFTS.values).toUpperCase()], 
            Cashups: state=> state.items[(DATA.ITEMS.CASHUPS.values).toUpperCase()],
            JoinedCashups: state=> state.join[(DATA.ITEMS.CASHUPS.values).toUpperCase()],
        }), 
        OutletsData(){ 
            let Outlets = this.Outlets
            let JoinedOutlets = this.JoinedOutlets
            let items = JoinedOutlets?JoinedOutlets:Outlets 
            return items
        }, 
        OutletsFilter(){ 
            let outlets = this.OutletsData 
            let items = [
                // {code:0,name:"All Outlets"}
            ]
            if (outlets) {
                items.push(...outlets)
            }
            return items
        }, 
        DayShiftsData(){ 
            let DayShifts = this.DayShifts
            let JoinedDayShifts = this.JoinedDayShifts
            let items = JoinedDayShifts?JoinedDayShifts:DayShifts  
            if(!items){return null}
            let list = [...items]
            list.sort(this.MBS.actions.dynamicSort("local_created_at",false))   
            return list 
        }, 
        DayShiftsFiltered(){
            const input_outlets = this.input_outlets
            const days = this.DayShiftsData
            const from_date = this.inputFromDate
            const to_date = this.inputToDate
            const difference = this.difference
            if(!days){return null}
            // if(!this.MBS.actions.SIZE(input_outlets)){return days}
            // if(input_outlets[0] == 0){return days}
            let filtered = days.filter(day=>{
                const index = input_outlets?.indexOf(day.outlet_code)
                const is_outlet =  this.MBS.actions.SIZE(input_outlets)?index != -1:true
                const open_date = day.local_created_at
                const close_date = day.auto_closed?day.auto_closed_date:day.local_close_at
                const open_moment = moment(moment(open_date).format("yyyy-MM-D"))
                const close_moment = moment(moment(close_date).format("yyyy-MM-D"))
                const is_open = open_moment.isBetween(from_date,to_date,'','[]')
                const is_close = close_moment.isBetween(from_date,to_date,'','[]')
                return is_outlet && (is_open || is_close)
            })  
            console.log("DayShiftsFiltered",filtered)
            return filtered
        },
        DayShiftsFiltered_(){
            const days = this.DayShiftsFiltered
            const codes = this.input_outlets
            const filtered =  days.filter(day=>{
                const index = codes?.indexOf(day.outlet_code)
                const is_outlet =  this.MBS.actions.SIZE(codes)?index != -1:true
                return is_outlet
            })
            return filtered
        }, 
        DayShiftsKeys(){
            const dayshifts = this.DayShiftsFiltered_
            if(!dayshifts){return null}
            let codes = []
            dayshifts.forEach(day => {
                codes.push(day.key) 
            });
            return codes
        },
        SelectedDayShiftsKeys(){
            const dayshifts = this.selected
            if(!dayshifts){return null}
            let codes = []
            dayshifts.forEach(day => {
                codes.push(day.key) 
            });
            return codes
        },
        OptionalDays(){ 
            let days = this.optional_days
            if (days) {
               return days 
            }
            return  [
                {name:"Today",days:0,from:"0",from_type:"days"},
                {name:"Last 7 Days",days:7,from:"7",from_type:"days"},
                {name:"Last 30 Days",days:30,from:"30",from_type:"days"},
                {name:"Last 3 Months",days:90,from:"90",from_type:"days"},
                {name:"Last 6 Months",days:180,from:"180",from_type:"days"},
                {name:"Last 12 Months",days:365,from:"12",from_type:"months"},
            ]
        },  
         
    },
    methods:{
        setOutletsFilter(newVal) {
            if (newVal && newVal.length > 0) {
            // Map all codes to an array to select everything
            this.input_outlets = newVal.map(item => toNumber(item));
            }
        },
        DEFAULT(default_days){
            try { 
                if (!default_days) {
                    default_days = this.default_days
                }
                if (default_days) {
                    let item = {from:default_days,from_type:"days"} 
                    this.CHANGE_DATE(item)
                }    
                this.APPLY_DATE() 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'CHANGE_DATE',
                    page:NAME, 
                }) 
            }
            
        },
        APPLY_DATE(){
            try { 
                this.fromDate = this.inputFromDate
                this.toDate = this.inputToDate 
                this.difference = this.DIFF(this.fromDate,this.toDate)
                this.menuDateSelect = false  
                let send_data = {
                    from_date:this.fromDate,
                    to_date:this.toDate,
                    difference:this.difference,
                    outlet_code:this.input_outlets,
                    outlets:this.OutletsFilter,
                    dayshifts:this.DayShiftsFiltered_,
                    dayshifts_keys:this.DayShiftsKeys,
                    selected_dayshifts:this.selected,
                    selected_dayshifts_keys:this.SelectedDayShiftsKeys,
                }
                this.$emit('input', send_data )
                this.$emit('apply', send_data )

            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'CHANGE_DATE',
                    page:NAME, 
                }) 
            }
            
        },
        GET_DAYSHIFT_SELECTOR_DATA(){
            try { 
                this.fromDate = this.inputFromDate
                this.toDate = this.inputToDate 
                this.difference = this.DIFF(this.fromDate,this.toDate)
                this.menuDateSelect = false  
                let send_data = {
                    from_date:this.fromDate,
                    to_date:this.toDate,
                    difference:this.difference,
                    outlet_code:this.input_outlets,
                    outlets:this.OutletsFilter,
                    dayshifts:this.DayShiftsFiltered_,
                    dayshifts_keys:this.DayShiftsKeys,
                    selected_dayshifts:this.selected,
                    selected_dayshifts_keys:this.SelectedDayShiftsKeys,
                }
                this.$emit('input', send_data )
                this.$emit('apply', send_data )
                return send_data
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'CHANGE_DATE',
                    page:NAME, 
                }) 
            }
            
        },
        CHANGE_DATE(item){
            try { 
                let from = item?item.from:null
                let from_type = item?item.from_type:null
                let to = item?item.to:null
                let to_type = item?item.to_type:null 
                if (from) {
                    this.inputFromDate = moment().subtract(from,from_type).format('yyyy-MM-DD') 
                }else {
                    this.inputFromDate = moment().format('yyyy-MM-DD') 
                }
                if (to) {
                    this.inputToDate = moment().subtract(to,to_type).format('yyyy-MM-DD') 
                }else {
                    this.inputToDate = moment().format('yyyy-MM-DD') 
                }
                 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'CHANGE_DATE',
                    page:NAME, 
                }) 
            }
            
        },
        DIFF(from,to,type="days"){
            try { 
                let a = moment(from)
                let b = moment(to)
                let diff = b.diff(a,type) 
                return diff
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'CHANGE_DATE',
                    page:NAME, 
                }) 
            }
            
        },

        //--------
        DIALOG_YES(action){ 
            if (action) {
                if (action.code ===NAME+"=ADD-SERVICE") {
                    if (this.input.check ) {
                        this.input.check = false 
                        this.$store.dispatch("fi_add",{
                            action:"Services",
                            path:"MBS/SETTINGS/Services/",
                            data:this.input
                        }) 
                    } 
                } 
                if (action.code ===NAME+"=REGISTER-TIMEOUT") {
                    
                }
                if (action.code ===NAME+"=GO-TO-PROFILE") {
                    this.MBS.actions.go('/profile')
                }
                if (action.code ===NAME+"=RELOAD-PAGE") {
                    this.RELOAD_PAGE()
                }
                if (action.code ===NAME+"=CANCEL-SIGNING") {
                    
                }
                
            }
        }, 
         
         
    },
   
    watch:{ 
        us(value){ 
        },
        processes(value){ 
        },
        input_outlets(value){ 
            console.log(value,"input_outlets.....");
            this.fromDate = this.inputFromDate
            this.toDate = this.inputToDate 
            this.difference = this.DIFF(this.fromDate,this.toDate)
            this.menuDateSelect = false  
            let send_data = {
                from_date:this.fromDate,
                to_date:this.toDate,
                difference:this.difference,
                outlet_code:this.input_outlets,
                outlets:this.OutletsFilter,
                dayshifts:this.DayShiftsFiltered_,
                dayshifts_keys:this.DayShiftsKeys,
                selected_dayshifts:this.selected,
                selected_dayshifts_keys:this.SelectedDayShiftsKeys,
            }
            this.$emit('input', send_data )
            
        },  
        dialog(value){ 
            this.inputLoading = false
        },
        selected(value){ 
            console.log(value,'selected.....');
            this.fromDate = this.inputFromDate
            this.toDate = this.inputToDate 
            this.difference = this.DIFF(this.fromDate,this.toDate)
            this.menuDateSelect = false  
            let send_data = {
                from_date:this.fromDate,
                to_date:this.toDate,
                difference:this.difference,
                outlet_code:this.input_outlets,
                outlets:this.OutletsFilter,
                dayshifts:this.DayShiftsFiltered_,
                dayshifts_keys:this.DayShiftsKeys,
                selected_dayshifts:value,
                selected_dayshifts_keys:this.SelectedDayShiftsKeys,
            }
            this.$emit('input', send_data )
            this.$emit('apply', send_data )

            console.log(send_data,'send_data.....');
            
        },
        fromDate(value){ 
            this.$emit('input', {
                from_date:value,
                to_date:this.toDate,
                difference:this.difference,
                outlet_code:this.input_outlets,
                outlets:this.OutletsFilter,
                dayshifts:this.DayShiftsFiltered_,
                dayshifts_keys:this.DayShiftsKeys,
                selected_dayshifts:this.selected,
                selected_dayshifts_keys:this.SelectedDayShiftsKeys,
            })

            console.log(value,'fromDate.....');
            
        },
        toDate(value){ 
            console.log(value,'toDate.....');
            this.$emit('input', {
                from_date:this.fromDate,
                to_date:value,
                difference:this.difference,
                outlet_code:this.input_outlets,
                outlets:this.OutletsFilter,
                dayshifts:this.DayShiftsFiltered_,
                dayshifts_keys:this.DayShiftsKeys,
                selected_dayshifts:this.selected,
                selected_dayshifts_keys:this.SelectedDayShiftsKeys,
            })
        },  
        inputFromDate(value){ 
            console.log(value,'inputFromDate.....');
            this.fromDate = value
        },
        inputToDate(value){ 
            console.log(value,'inputToDate.....');
            this.toDate = value
        },
    }
}
</script> 